export default __webpack_public_path__ + "static/media/drivers.1c00c128.svg";